@let localeObj = storeSvc.userStore.localeObj;
@let isAlternatePropertiesExist = storeSvc.propInfo()?.isAlternatePropertiesExist;

<div class="calendar-indications gap-3 d-inline-flex flex-wrap">
  <div class="calendar-indication d-flex align-items-center selected-dates">
    <div class="color-box"></div>
    <div class="text" [innerHTML]="localeObj()?.tf_1_Calendar_rateCalender_selectedDates | safeHtml"></div>
  </div>

  <div class="calendar-indication d-flex align-items-center unavailable-dates">
    <div class="color-box"></div>
    <div class="text" [innerHTML]="localeObj()?.tf_1_Calendar_rateCalender_unavailable | safeHtml"></div>
  </div>

  <div class="calendar-indication d-flex align-items-center restricted-dates">
    <div class="color-box"></div>
    <div class="text" [innerHTML]="localeObj()?.tf_1_Calendar_rateCalender_restrictions | safeHtml"></div>
  </div>

  @if (isAlternatePropertiesExist) {
    <div class="calendar-indication d-flex align-items-center alt-property-available">
      <div class="color-box"></div>
      <div class="text" [innerHTML]="localeObj()?.tf_4_Calendar_altPropertyTooltip | safeHtml"></div>
    </div>
  }
</div>
